import { ActionEnum } from '@common/graphql/operations';
export var schoolBalanceActionsArray = [
    ActionEnum.ActionBillingStudentPaidCourse,
    ActionEnum.ActionBillingSchoolRequisitesAccepted,
    ActionEnum.ActionBillingSchoolRequisitesDeclined,
    ActionEnum.ActionBillingWithdrawAccepted,
    ActionEnum.ActionBillingWithdrawDecline,
];
export var schoolPlansActionsArray = [
    ActionEnum.ActionTariffSubscriptionExpirationIn_1Day,
    ActionEnum.ActionTariffSubscriptionExpirationIn_3Days,
    ActionEnum.ActionTariffSubscriptionExpirationIn_7Days,
    ActionEnum.ActionTariffSubscriptionExpired,
    ActionEnum.ActionTariffSubscriptionRecurrentPaymentFailure,
    ActionEnum.ActionTariffFeatureLimitExceeded
];
export var schoolPartnerActionsArray = [
    ActionEnum.ActionAffiliateRequisitesAccepted,
    ActionEnum.ActionAffiliateRequisitesDeclined,
    ActionEnum.ActionAffiliateWithdrawAccepted,
    ActionEnum.ActionAffiliateWithdrawDeclined,
    ActionEnum.ActionAffiliateLevelUpdate,
    ActionEnum.ActionAffiliateReferralPayment,
];
export var studentCourseActionsArray = [
    ActionEnum.ActionCourseAccessStudentInvite,
    ActionEnum.ActionCourseAccessStudentAccessEnd_3Days,
    ActionEnum.ActionCourseAccessStudentNewStep,
];
export var studentLessonActionsArray = [
    ActionEnum.ActionCoursePublishedNewLesson,
    ActionEnum.ActionCourseUpcomingWebinarStudent,
    ActionEnum.ActionCourseWebinarStartStudent,
    ActionEnum.ActionHomeworkTeacherSent,
    ActionEnum.ActionHomeworksTeacherSentCron,
    ActionEnum.ActionCourseAccessStudentNewLesson,
    ActionEnum.ActionDeadlineUpcoming_3Days,
    ActionEnum.ActionDeadlineUpcoming_1Day,
    ActionEnum.ActionDeadlineExpired,
];
export var studentPartnerActionsArray = [
    ActionEnum.ActionAffiliateRequisitesAccepted,
    ActionEnum.ActionAffiliateRequisitesDeclined,
    ActionEnum.ActionAffiliateWithdrawAccepted,
    ActionEnum.ActionAffiliateWithdrawDeclined,
    ActionEnum.ActionAffiliateLevelUpdate,
    ActionEnum.ActionAffiliateReferralPayment,
];
export var studentWebinarActionsArray = [
    ActionEnum.ActionWebinarUpcomingStreamStudent,
    ActionEnum.ActionWebinarUpcomingStreamStudentInvite,
];
export var studentTableActionsArray = [
    ActionEnum.ActionStudentExportStudentList,
    ActionEnum.ActionStudentExportStudentProgress
];
